<template>
    <div class="pmtdiv">
        <smallbutton :toplabel="name" @click="start()" v-if="showButton" :buttonclass="buttonClass"/>
        <linkbutton :toplabel="name" @click="start()" v-if="!showButton"/>
        <!--  MODAL -->
          <actionmodalwide ref="mymodal"> 
            <template v-slot:body>
                <form ref="balform">
                    
                    <label class="titlelabel">{{name}}</label>
                    <br/>
                    <optionbutton :itemList="ticketTypeList" @select="selectTicketType" :initialSelectedId="param2"/>
                    <linkbutton :toplabel="toggleText" @click="showAsTickets=!showAsTickets"/>
                    <br>

                    <div v-if="ticketType=='Suspended'">
                        <div>
                            <label v-if="suspendedTicketCount==0">There are no suspended tickets</label>
                        </div>
                        <div class="horizFlex" v-if="showAsTickets">
                            <div  v-for="t in suspendedTicketList" :key="t.id" :value="t.id" class="ticketandbuttons">
                                
                                <smallbutton buttonclass="ticketviewbutton buttondiv"  @click="go(t.id)" toplabel="Go To Ticket" />
                                <div class="margintop">
                                    <ticketv :ticket="t"/>
                                </div>
                                
                            </div>
                        </div>
                        <div v-if="!showAsTickets">
                            <div  v-for="t in suspendedTicketList" :key="t.id" :value="t.id" >
                                <ticketh :ticket="t" @gototicket="go(t.id)"/>
                            </div>
                        </div>
                    </div>
                    <div v-if="ticketType=='Completed'">
                        <div>
                            <label v-if="completedTicketCount==0">There are no completed tickets today</label>
                        </div>
                        <div class="horizFlex" v-if="showAsTickets">
                            <div  v-for="t in completedTicketList" :key="t.id" :value="t.id" class="ticketandbuttons">
                                <ticketv :ticket="t"/>
                                
                            </div>
                        </div>
                        <div v-if="!showAsTickets">
                            <div  v-for="t in completedTicketList" :key="t.id" :value="t.id" >
                                <ticketh :ticket="t" @gototicket="go(t.id)"/>
                            </div>
                        </div>
                    </div>
                    <div v-if="ticketType=='Kitchen'">
                        <div>
                            <label v-if="kitchenTicketCount==0">There are no kitchen tickets</label>
                        </div>
                        <div class="horizFlex" v-if="showAsTickets">
                            <div  v-for="t in kitchenTicketList" :key="t.id" :value="t.id" class="ticketandbuttons">
                                
                                <div class="horizFlexStretch ">
                                    <smallbutton buttonclass="ticketviewbutton buttondiv"  @click="kitchendone(t)" toplabel="Complete" />
                                    <smallbutton buttonclass="ticketviewbutton buttondiv"  @click="go(t.id)" toplabel="Go To Ticket" />

                                </div>
                                <div class="margintop">
                                    <ticketv :ticket="t" :prepAreas="prepAreas"/>
                                </div>
                                
                            </div>
                        </div>
                         <div v-if="!showAsTickets">
                            <div  v-for="t in kitchenTicketList" :key="t.id" :value="t.id" >
                                <ticketh :ticket="t" @gototicket="go(t.id)"/>
                            </div>
                        </div>
                    </div>
                               
         
                    <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close"/>
                    <div>
                        <label class="responsemessage">{{responseMessage}}</label>
                    </div>
         
                </form>
                
                
            </template>
          </actionmodalwide>
        </div>
    </template>
    
    <script>
    import {mapFields} from 'vuex-map-fields'
    import format from '../../style/format.js'
    import smallbutton from '../controls/button.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import actionmodalwide from '../controls/actionmodalwide.vue'
    import formentry from '../controls/entry.vue'
    import datamethods from '../../services/datamethods.js'
    import confirm from '../actions/confirm.vue'
    import ticketv from './ticketv.vue'
    import ticketh from './ticketh.vue'
    import pos from '../../services/pos.js'
    import pay from '../../services/pay.js'
      import pos_culinary from '../../services/pos_culinary.js'
     import optionbutton from '../controls/optionbutton.vue'
    export default {
        name:'ticketshoriz',
        components:{
            smallbutton,
            actionmodalwide,
            formentry,
            linkbutton,
            confirm,
            ticketv,
            optionbutton,
            ticketh
        },
        props:{
           
            showButton:{
                type:Boolean,
                default:true
            },
            name:{
                type:String,
                default:"Today's Tickets"
            },
            defaultAmount:{
                type:Number,
            },
            numberDataLabel:{
                type:String,
                default:''
            },
            buttonClass:{
                type:String,
                default:'button buttonprimary bottom10'
            }
            
        },
        mixins:[format, datamethods,pos,pay,pos_culinary],
       
        data(){
            return{
                showAsTickets:true,

                param2:1,

                ticketTypeList:[
                    {
                        id:1,
                        name:'Kitchen'
                    },
                    {
                        id:2,
                        name:'Suspended'
                    },
                    {
                        id:3,
                        name:'Completed'
                    }
                ],
                ticketType:'Kitchen',
                ticketList:[],
                suspendedTicketList:[],
                kitchenTicketList:[], 
                completedTicketList:[],

                ticketId:0,
                trueParam:true, 
     
                savedTicketId:0,
                receiptData:null
            }
        },
        computed:{
            ...mapFields([
                'responseMessage',
                'pleaseWait',
                'location',
                'terminalId',
                'businessDayId',
                'prepAreas'
     
            ]),
            toggleText(){
                if(this.showAsTickets){return "Show as Records"}
                else{return "Show as Tickets"}
            },
           ticketCount(){
            return this.ticketList.length
           },
           suspendedTicketCount(){
            return this.suspendedTicketList.length
           },
           kitchenTicketCount(){
            return this.kitchenTicketList.length
           },
           completedTicketCount(){
                return this.completedTicketList.length
           },
           /* kitchenTicketList(){
                let temp = this.ticketList;
                if(temp!=undefined){
                    temp = temp.filter((item)=>{
                        return (item.statusName=='InKitchen')
                    })
                }
                
                return temp
           },
           suspendedTicketList(){
            let temp = this.ticketList;
                if(temp!=undefined){
                    temp = temp.filter((item)=>{
                        return (item.statusName=='InService')
                    })
                }
                
                return temp
           },
           completedTicketList(){
            let temp = this.ticketList;
                if(temp!=undefined){
                    temp = temp.filter((item)=>{
                        return (item.statusName=='CheckedOut')
                    })
                }
                
                return temp
           } */
        },
        methods:{
            selectTicketType(id,name){
                this.ticketType=name
            },
            go(ticketid){
                this.gototicket(ticketid)
                this.$refs.mymodal.closeModal()
            },
            async kitchendone(ticket){
                await this.suspendticket(ticket)
                this.getAllTickets()
            },
            toDate(dt){
                return this.$options.filters.formatTime_NoSeconds(dt);
            },
            
        
            tclass(g){
                let c = "tclass"
                return c
            },
            
            start(){
                if(this.prepAreas.length==0){this.GetPrepAreas()}
                this.getAllTickets()
                /* this.getKitchenTickets()
                this.gettickets()
                this.getsuspendedtickets() */
                this.$refs.mymodal.openModal()
            },
            async getAllTickets(){
                //this.inPayment=true
                let req = {
                    locationId:this.location.id,
                    terminalId:this.terminalId
                }
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'gettodaytickets_all')
                //handle response
            
                if(response.Successful){
                    this.ticketList=response.ticketList
                    
                    

                    await this.fillInLineItems()

                }else{
                this.responseMessage = response.Message
                }
                this.pleaseWait=false;
                        
            
            },
            
            
           
            async fillInLineItems(){
                this.kitchenTicketList=[];
                this.suspendedTicketList=[];
                this.completedTicketList=[];

                var i;
                    for (i = 0; i <= this.ticketList.length - 1; i++) {
                    

                        //this.ticketList[i]= await this.getticketdetail(this.ticketList[i].id)
                        var tick = await this.getticketdetail(this.ticketList[i].id)
                        switch (tick.statusName) {
                            case 'InKitchen':
                                this.kitchenTicketList.push(tick)
                                
                                break;
                            case 'InService':
                                this.suspendedTicketList.push(tick)
                                break;
                            case 'CheckedOut':
                                this.completedTicketList.push(tick)
                                break;
                            default:
                                break;
                        }
                    
                    }
            },
           
            async getticketdetail(id){
                let req = {
                    ticket:{
                        id:id
                    }
                }  
                    //call api
                    this.$store.dispatch('beforeAPI');
                    var response = await this.callAPI(req,'ticket')
                    //handle response
                
                    if(response.Successful){
                    return response.ticket

                    
                    
                    }else{
                    this.responseMessage = response.Message
                    }
                    this.pleaseWait=false;
                },
                
        },




        /* async getKitchenTickets(){
                this.inPayment=true
                let req = {
                    locationId:this.location.id,
                    terminalId:this.terminalId
                }
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'getkitchentickets')
                //handle response
            
                if(response.Successful){
                    this.kitchenTicketList=response.ticketList
                    
                    

                    await this.fillInLineItems_Kitchen()

                }else{
                this.responseMessage = response.Message
                }
                this.pleaseWait=false;
                        
            }, */
            /* async getsuspendedtickets(){
                this.inPayment=true
                let req = {
                    businessDayId:this.businessDayId
                }
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'getsuspendedtickets')
                //handle response
            
                if(response.Successful){
                    this.suspendedTicketList=response.ticketList
                    await this.fillInLineItems_suspended()
                   
                    
                }else{
                this.responseMessage = response.Message
                }
                this.pleaseWait=false;
                        
            }, */
            /* async gettickets(){
                this.inPayment=true
                let req = {
                    locationId:this.location.id,
                    terminalId:this.terminalId
                }
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'gettodaytickets')
                //handle response
            
                if(response.Successful){
                    this.ticketList=response.ticketList
                    
                    

                    await this.fillInLineItems()

                }else{
                this.responseMessage = response.Message
                }
                this.pleaseWait=false;
                        
            }, */
            /* async fillInLineItems_suspended(){
                var i;
                    for (i = 0; i <= this.suspendedTicketList.length - 1; i++) {
                    
                        this.suspendedTicketList[i]= await this.getticketdetail(this.suspendedTicketList[i].id)
                    
                    }
            },
            async fillInLineItems_Kitchen(){
                var i;
                    for (i = 0; i <= this.kitchenTicketList.length - 1; i++) {
                    
                        this.kitchenTicketList[i]= await this.getticketdetail(this.kitchenTicketList[i].id)
                    
                    }
            }, */
    }
    
    </script>
    
    <style>
   
    
   
    .leftjustify{
        text-align: left;
    }
    .rightjustify{
        text-align: right;
    }
    .ticketviewbutton{
        background-color: var(--ticket-action-buttoncolor);
        color:var(--light-text-color);
        border: none;
    border-radius:3px;
    width:95px;
    height:35px;
    padding:0px;
    font-size: medium;
    margin:0px;
  text-decoration: none;
    }
    .buttondiv{
        margin-top:5px;
    }
    .ticketandbuttons{
        margin:5px;
    }
    .margintop{
        margin-top: 5px;
    }
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    